<template>
  <div class="ControlLibrary"  >
    <model-close @close="$modal.hide('controlLibraryModel')"></model-close>
    <h5>控件库</h5>
    <p class="des" >点击对应的控件添加到页面</p>
    <div class="ControlLibraryList modal-box">
<!--      <div class="ControlLibraryList-ModalBox">-->
        <li class="hideMove listControl"
            v-for="(item,index) in controlLibraryList"
            @click="create(item)"
            :key="index"
        >
          {{item.name}}
        </li>

        <div style="padding-bottom: 30px"></div>
      </div>
<!--    </div>-->
  </div>
</template>

<script>
import ModelClose from "@/components/modal/modelClose";
import modal from "@/components/modal/modal";
export default {
  name: "ControlLibraryList",
  components: {ModelClose},
  data() {
    return {

     }
  },
  props : ['controlLibraryList','scale'],
  created() {

    setTimeout(()=>{
      modal.handle()
    })
  },
  methods : {


    /**
     * 移动印章进入文件区
     */
    create( item) {

      let id = "input-" + new Date().getTime() +'' + Math.round(Math.random() * 80)

      // 鼠标抬开

        //标记为鼠标印章停止移动

        // let pageObj = document.getElementsByClassName("d-sign-doc-png")[this.now_page];

        this.$emit("create", {
          id : id,
          filler : "不设置",
          width : ( item.id===7 || item.id===6 ? 30 : item.width) * this.scale,
          height : ( item.id===7 || item.id===6 ? 30 : item.height) * this.scale,
          control_library_id : item.id,
          name : item.name,
          is_require : -1,
          sign_id : -1,
          display_font : item.display_font, //是否显示字体
          font_type : -1, //字体类型 -1默认
          font_size : -1, //字体大小 -1默认
          display_color : item.display_color,
          display_background_color : item.display_background_color,
          display_font_interval : item.display_font_interval,
          display_font_underline : item.display_font_underline,
          display_select_seal : item.display_select_seal,
          display_select_seal_value : "handwritten",
          display_font_align : item.display_font_align,
          font_align :  "left",
          font_underline : -1,
          font_interval : -1,
          color : "#111111",
          background_color : -1,
          display_date : item.display_date,
          date : "YYYY/MM/DD",
          display_number : item.display_number,
          font_number : -1,
          display_money : item.display_money,
          font_money : -1,
          display_doc_number : item.display_doc_number,
          doc_number_length : 8,
          doc_number_prefix : "",
          doc_number_suffix : "",
          auto_sign_filler : "请选择",
          radio_list_selected : 0,
          display_checkbox : item.display_checkbox,
          display_radio : item.display_radio,
          checkbox_selected : -1
        });
      // this.$emit("create", {
      //   id : id,
      //   content : "",
      //   default_value : "",
      //   export : "",
      //   field : "",
      //   name : item.name,
      //   page : 0,
      //   read_only : "",
      //   required : "No",
      //
      //   option : {
      //     filler : "不设置",
      //     control_library_id : item.id,
      //     font_type : -1, //字体类型 -1默认
      //     font_size : -1, //字体大小 -1默认
      //     font_align :  "left",
      //     font_underline : -1,
      //     font_interval : -1,
      //     color : "#111111",
      //     background_color : -1,
      //     date : "YYYY/MM/DD",
      //     font_number : -1,
      //     font_money : -1,
      //     doc_number_length : 8,
      //     doc_number_prefix : "",
      //     doc_number_suffix : "",
      //     auto_sign_filler : "请选择",
      //     radio_list_selected : 0,
      //     checkbox_selected : -1,
      //   },
      //   position : {
      //     width : ( item.id===7 || item.id===6 ? 30 : item.width) * this.scale,
      //     height : ( item.id===7 || item.id===6 ? 30 : item.height) * this.scale,
      //     x : 0,
      //     y : 0,
      //     page_width : 650,
      //     page_height : 0,
      //   },
      //   display : {
      //     display_color : item.display_color,
      //     display_background_color : item.display_background_color,
      //     display_font_interval : item.display_font_interval,
      //     display_font_underline : item.display_font_underline,
      //     display_select_seal : item.display_select_seal,
      //     display_select_seal_value : "handwritten",
      //     display_font_align : item.display_font_align,
      //     display_font : item.display_font, //是否显示字体
      //     display_date : item.display_date,
      //     display_number : item.display_number,
      //     display_money : item.display_money,
      //     display_doc_number : item.display_doc_number,
      //     display_checkbox : item.display_checkbox,
      //     display_radio : item.display_radio,
      //   }
      // });


      this.$modal.hide('controlLibraryModel')


    }
  }
}
</script>

<style scoped>

.ControlLibraryList {
  overflow: auto;
  height: 330px;
  margin-left: 30px;
  margin-right: 5px;
}

@media only screen and  (max-width:650px) {
  .ControlLibraryList {
    height: 60vh;
  }
}


.ControlLibraryList  .listControl {
  border-radius: 3px;
  border: 1px dashed rgba(0,0,0,.3);
  margin-top: 15px;
  padding: 8px 15px 8px 15px;
  list-style: none;
  position: relative;
  margin-right: 25px;
}
.ControlLibraryList li:hover {
  border: 1px dashed var(--blue);
  cursor: move;
  /*color: var(--blue);*/
}

.hideMove {
  moz-user-select: -moz-none;
  -moz-user-select: none;
  -o-user-select:none;
  -khtml-user-select:none;
  -webkit-user-select:none;
  -ms-user-select:none;
  user-select:none;
}



</style>
